import { apiRoutes, externalRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug) {
    const url = FetchHelpers.toCDN(apiRoutes.templateGroupPath(1, slug));
    return FetchHelpers.get(url);
  },
  recommendedTemplatesGroup(templateGroupId, templateGroupType) {
    const url = externalRoutes.relatedTemplateGroupsPath(templateGroupId, templateGroupType);
    return FetchHelpers.get(url);
  },
};
